import React from 'react';
import { reduxForm, Field } from 'redux-form';
import { useSelector } from 'react-redux';
import { Input, Select, Textarea } from '../../../../../../itrust_common/components/form';

let VisionWebOrderForm = props => {
  const { handleSubmit } = props;
  const jobTypeOptions = [
    { name: 'Select Options', value: '' },
    { name: 'Frame To Come', value: 'Frame To Come' },
    { name: 'Lab Supplied', value: 'Lab Supplied' },
    { name: 'Remote Edge', value: 'Remote Edge' },
    { name: 'Uncut', value: 'Uncut' }
  ];
  const storeSetting = useSelector((state) => state.storeSetting);
  const visionWebSettings = storeSetting?.filtered_store_settings?.vision_web || [];
  const latestSetting = [...visionWebSettings].reverse().find(item => item.store_config?.username) || visionWebSettings[visionWebSettings.length - 1];
  const locations = latestSetting?.store_config?.locations || [];

  const locationOptions = [
    { name: 'Select Location', value: '' },
    ...locations.map(loc => ({
      name: loc.name || loc.id,
      value: loc.id

    }))
  ];

  return (
    <form onSubmit={handleSubmit}>
      <Field name="bill_account" label="Bill Account" component={Input} className="form-control" wrapperClasses="col-12 form-group" />
      <Field name="ship_account" label="Ship Account" component={Input} className="form-control" wrapperClasses="col-12 form-group" />
      <div className='d-flex align-items-center'>
      <Field name="job_type" label="Job Type" component={Select} className="form-control" data={jobTypeOptions} wrapperClasses="col-6 form-group" textField="name"
        valueField="value" />
      <Field name="location_id" label="Location" component={Select} className="form-control" data={locationOptions} wrapperClasses="col-6 form-group" textField="name" valueField="value" />
        </div>
      <Field name="message_to_lab" label="Message to Lab" component={Textarea} rows="5" className="form-control" wrapperClasses="col-12 form-group" />
    </form>
  )
}

VisionWebOrderForm = reduxForm({
  enableReinitialize: true,
})(VisionWebOrderForm);

export default VisionWebOrderForm;
